import { useState, useEffect, useCallback } from "react";
import Reveal from "./Reveal";
import { ChevronLeft, ChevronRight } from "lucide-react";

const quotes = [
  {
    text: "Picaso Studios transformed my wedding day into pure poetry. Twenty years of mastery shows in every detail — I have never felt more myself, only elevated.",
    author: "Isabella Moreau",
    role: "Bride, Summer 2025",
  },
  {
    text: "The Scalp Lounge is a sanctuary. I came for a treatment and left feeling completely restored. This is wellness as an art form.",
    author: "Catherine Ng",
    role: "Wellness Client",
  },
  {
    text: "An effortlessly elegant experience from consultation to the final veil. The artistry here is simply unmatched in Vaughan.",
    author: "Sophia Bellini",
    role: "Bride, Autumn 2024",
  },
];

export const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % quotes.length), 7000);
    return () => clearInterval(t);
  }, [tick]);

  const go = useCallback((dir) => {
    setIndex((i) => (i + dir + quotes.length) % quotes.length);
    setTick((n) => n + 1);
  }, []);

  const q = quotes[index];

  return (
    <section
      id="studio"
      data-testid="testimonials-section"
      className="py-32 md:py-40 bg-[#F7F4EA]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <p className="text-umber text-xs uppercase tracking-[0.3em] mb-12">In Their Words</p>
        </Reveal>
        <Reveal key={index}>
          <blockquote className="font-serif font-light text-2xl md:text-4xl leading-[1.4] text-obsidian italic">
            “{q.text}”
          </blockquote>
          <div className="mt-10">
            <p className="text-sm uppercase tracking-[0.2em] text-obsidian" data-testid="testimonial-author">
              {q.author}
            </p>
            <p className="text-xs text-obsidian/50 mt-2">{q.role}</p>
          </div>
        </Reveal>

        <div className="flex items-center justify-center gap-8 mt-14">
          <button
            data-testid="testimonial-prev"
            onClick={() => go(-1)}
            className="text-obsidian/50 hover:text-champagne transition-colors"
            aria-label="Previous testimonial"
          >
            <ChevronLeft size={22} />
          </button>
          <div className="flex gap-2">
            {quotes.map((_, i) => (
              <span
                key={i}
                className={`h-px transition-all duration-500 ${
                  i === index ? "w-8 bg-champagne" : "w-4 bg-obsidian/20"
                }`}
              />
            ))}
          </div>
          <button
            data-testid="testimonial-next"
            onClick={() => go(1)}
            className="text-obsidian/50 hover:text-champagne transition-colors"
            aria-label="Next testimonial"
          >
            <ChevronRight size={22} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
